var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c("select-label", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.getReadMode(),
            expression: "!getReadMode()",
          },
        ],
        ref: "selectLabel",
        staticStyle: { width: "100%" },
        attrs: {
          list: _vm.field.options.optionItems || [],
          value: _vm.fieldModel,
          props: { children: "children", label: "name" },
        },
        on: {
          handleLabelConf: function ($event) {
            return _vm.handleLabelConf($event, _vm.val)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "custom",
            fn: function () {
              return [
                _c(
                  "el-select",
                  {
                    ref: "fieldEditor",
                    staticClass: "full-width-input",
                    attrs: {
                      "popper-class": "popper-class",
                      size: _vm.field.options.size,
                      "default-first-option": _vm.allowDefaultFirstOption,
                      multiple: true,
                      placeholder:
                        _vm.field.options.placeholder ||
                        _vm.i18nt("render.hint.selectPlaceholder"),
                      remote: _vm.field.options.remote,
                      "remote-method": _vm.remoteMethod,
                    },
                    on: { focus: _vm.handleFocusCustomEvent },
                    model: {
                      value: _vm.fieldModel,
                      callback: function ($$v) {
                        _vm.fieldModel = $$v
                      },
                      expression: "fieldModel",
                    },
                  },
                  _vm._l(_vm.labelData, function (item) {
                    return _c("el-option", {
                      key: item.id,
                      attrs: { label: item.name, value: item.id },
                    })
                  }),
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.getReadMode()
        ? [
            _c(
              "div",
              { staticClass: "readonly-mode-field" },
              [
                _vm.contentForReadMode && _vm.contentForReadMode.length > 0
                  ? _vm._l(_vm.contentForReadMode, function (item) {
                      return _c(
                        "el-tag",
                        { key: item.id, staticClass: "mr10" },
                        [_vm._v(_vm._s(item))]
                      )
                    })
                  : _c("span", [
                      _vm._v(_vm._s(_vm.contentForReadMode || "--")),
                    ]),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }